import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { authKeys } from '@/features/auth/api'
import { setApiEventHandlers } from '@/lib/api'
import { queryClient } from '@/lib/query-client'
import { createAppRouter } from '@/router'
import '@/styles/globals.css'

const router = createAppRouter(queryClient)

const PUBLIC_PATHS = ['/login', '/register', '/invite/']

setApiEventHandlers({
  // Session expired / signed out elsewhere → back to login, preserving the destination.
  onUnauthenticated: () => {
    const { pathname, href } = router.state.location
    if (PUBLIC_PATHS.some((p) => pathname.startsWith(p))) return
    queryClient.setQueryData(authKeys.me(), null)
    void router.navigate({ to: '/login', search: { redirect: href } })
  },
  // Authenticated but no current tenant → onboarding ("create organization").
  onNoTenant: () => {
    if (router.state.location.pathname.startsWith('/onboarding') || router.state.location.pathname.startsWith('/admin')) return
    void queryClient.invalidateQueries({ queryKey: authKeys.me() })
    void router.navigate({ to: '/onboarding' })
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
